import { connect } from "react-redux";
import { userSlice } from "../store/reducers";
import { RootState, AppDispatch } from "../store";

//  import "../css/reader.css";

export interface TempProfilePage
{
  onLogout:()=> void;
}

const TempPageProfile: React.FC<TempProfilePage> = ({
  onLogout
}) =>
{
  
  return(
    <div>
      Pendente
    </div>
  )
};


const mapState = (state: RootState) => 
{
  const result = {};
  return result;
};

const mapDispatch = (dispatch: AppDispatch) => 
{
  const result:TempProfilePage = 
  {
    onLogout : ()=> dispatch(userSlice.actions.logout())
  };
  return result;
};

const WReader = connect(mapState, mapDispatch)(TempPageProfile);

export { WReader };
